import { render } from "./PastBillings.vue?vue&type=template&id=74704078&scoped=true"
import script from "./PastBillings.vue?vue&type=script&lang=js"
export * from "./PastBillings.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./PastBillings.vue?vue&type=style&index=2&id=74704078&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2424817344/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74704078"],['__file',"src/views/PastBillings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74704078"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74704078', __exports__)) {
    console.log('reload')
    api.reload('74704078', __exports__)
  }
  
  module.hot.accept("./PastBillings.vue?vue&type=template&id=74704078&scoped=true", () => {
    console.log('re-render')
    api.rerender('74704078', render)
  })

}


export default __exports__